/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CommentFragmentFragmentGQLType = (
  { __typename?: 'Comment' }
  & Pick<Types.CommentGQLType, 'id' | 'created_at' | 'updated_at' | 'comment' | 'authorUserId' | 'authorFirstName' | 'authorLastName' | 'authorOrganizationId' | 'authorOrganizationSlug' | 'authorOrganizationName'>
);

export type ThreadPermissionsFragmentFragmentGQLType = (
  { __typename?: 'ThreadPermissions' }
  & Pick<Types.ThreadPermissionsGQLType, 'organizationId' | 'organizationSlug' | 'organizationName'>
);

export type LatestThreadActionLogFragmentFragmentGQLType = (
  { __typename?: 'LatestThreadActionLog' }
  & Pick<Types.LatestThreadActionLogGQLType, 'userFirstName' | 'userLastName' | 'actionType'>
);

export type ThreadFragmentFragmentGQLType = (
  { __typename?: 'Thread' }
  & Pick<Types.ThreadGQLType, 'threadId' | 'created_at' | 'updated_at' | 'pinned' | 'resolved'>
  & { comments: Array<(
    { __typename?: 'Comment' }
    & CommentFragmentFragmentGQLType
  )>, threadPermissions: Array<(
    { __typename?: 'ThreadPermissions' }
    & ThreadPermissionsFragmentFragmentGQLType
  )>, latestActionLog?: Types.Maybe<(
    { __typename?: 'LatestThreadActionLog' }
    & LatestThreadActionLogFragmentFragmentGQLType
  )> }
);

export type GetThreadsForOrganizationQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetThreadsForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { threadsForOrganization: Array<(
    { __typename?: 'Thread' }
    & Pick<Types.ThreadGQLType, 'threadId' | 'created_at' | 'updated_at' | 'pinned' | 'resolved'>
    & { comments: Array<(
      { __typename?: 'Comment' }
      & Pick<Types.CommentGQLType, 'id' | 'created_at' | 'updated_at' | 'comment' | 'authorUserId' | 'authorFirstName' | 'authorLastName' | 'authorOrganizationId' | 'authorOrganizationSlug' | 'authorOrganizationName'>
    )>, threadPermissions: Array<(
      { __typename?: 'ThreadPermissions' }
      & Pick<Types.ThreadPermissionsGQLType, 'organizationId' | 'organizationSlug' | 'organizationName'>
    )>, latestActionLog?: Types.Maybe<(
      { __typename?: 'LatestThreadActionLog' }
      & Pick<Types.LatestThreadActionLogGQLType, 'userFirstName' | 'userLastName' | 'actionType'>
    )> }
  )> }
);

export type GetThreadIdsForOrganizationQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetThreadIdsForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'threadIds'>
);

export type GetThreadsQueryVariablesGQLType = Types.Exact<{
  threadIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
}>;


export type GetThreadsQueryGQLType = (
  { __typename?: 'Query' }
  & { threads: Array<(
    { __typename?: 'Thread' }
    & Pick<Types.ThreadGQLType, 'threadId' | 'created_at' | 'updated_at' | 'pinned' | 'resolved'>
    & { comments: Array<(
      { __typename?: 'Comment' }
      & Pick<Types.CommentGQLType, 'id' | 'created_at' | 'updated_at' | 'comment' | 'authorUserId' | 'authorFirstName' | 'authorLastName' | 'authorOrganizationId' | 'authorOrganizationSlug' | 'authorOrganizationName'>
    )>, threadPermissions: Array<(
      { __typename?: 'ThreadPermissions' }
      & Pick<Types.ThreadPermissionsGQLType, 'organizationId' | 'organizationSlug' | 'organizationName'>
    )>, latestActionLog?: Types.Maybe<(
      { __typename?: 'LatestThreadActionLog' }
      & Pick<Types.LatestThreadActionLogGQLType, 'userFirstName' | 'userLastName' | 'actionType'>
    )> }
  )> }
);

export type GetThreadQueryVariablesGQLType = Types.Exact<{
  threadId: Types.Scalars['UUID'];
}>;


export type GetThreadQueryGQLType = (
  { __typename?: 'Query' }
  & { thread: (
    { __typename?: 'Thread' }
    & Pick<Types.ThreadGQLType, 'threadId' | 'created_at' | 'updated_at' | 'pinned' | 'resolved'>
    & { comments: Array<(
      { __typename?: 'Comment' }
      & Pick<Types.CommentGQLType, 'id' | 'created_at' | 'updated_at' | 'comment' | 'authorUserId' | 'authorFirstName' | 'authorLastName' | 'authorOrganizationId' | 'authorOrganizationSlug' | 'authorOrganizationName'>
    )>, threadPermissions: Array<(
      { __typename?: 'ThreadPermissions' }
      & Pick<Types.ThreadPermissionsGQLType, 'organizationId' | 'organizationSlug' | 'organizationName'>
    )>, latestActionLog?: Types.Maybe<(
      { __typename?: 'LatestThreadActionLog' }
      & Pick<Types.LatestThreadActionLogGQLType, 'userFirstName' | 'userLastName' | 'actionType'>
    )> }
  ) }
);

export type CreateThreadActionMutationVariablesGQLType = Types.Exact<{
  userId: Types.Scalars['UUID'];
  threadId: Types.Scalars['UUID'];
  action: Types.ThreadActionGQLType;
}>;


export type CreateThreadActionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createThreadAction: (
    { __typename?: 'Thread' }
    & Pick<Types.ThreadGQLType, 'threadId' | 'created_at' | 'updated_at' | 'pinned' | 'resolved'>
    & { comments: Array<(
      { __typename?: 'Comment' }
      & Pick<Types.CommentGQLType, 'id' | 'created_at' | 'updated_at' | 'comment' | 'authorUserId' | 'authorFirstName' | 'authorLastName' | 'authorOrganizationId' | 'authorOrganizationSlug' | 'authorOrganizationName'>
    )>, threadPermissions: Array<(
      { __typename?: 'ThreadPermissions' }
      & Pick<Types.ThreadPermissionsGQLType, 'organizationId' | 'organizationSlug' | 'organizationName'>
    )>, latestActionLog?: Types.Maybe<(
      { __typename?: 'LatestThreadActionLog' }
      & Pick<Types.LatestThreadActionLogGQLType, 'userFirstName' | 'userLastName' | 'actionType'>
    )> }
  ) }
);

export type CreateNewCommentMutationVariablesGQLType = Types.Exact<{
  threadId: Types.Scalars['UUID'];
  comment: Types.Scalars['String'];
  authorUserId: Types.Scalars['UUID'];
}>;


export type CreateNewCommentMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<Types.MutationGQLType, 'newComment'>
);

export const CommentFragmentFragmentDocGQLType = gql`
    fragment CommentFragment on Comment {
  id
  created_at
  updated_at
  comment
  authorUserId
  authorFirstName
  authorLastName
  authorOrganizationId
  authorOrganizationSlug
  authorOrganizationName
}
    `;
export const ThreadPermissionsFragmentFragmentDocGQLType = gql`
    fragment ThreadPermissionsFragment on ThreadPermissions {
  organizationId
  organizationSlug
  organizationName
}
    `;
export const LatestThreadActionLogFragmentFragmentDocGQLType = gql`
    fragment LatestThreadActionLogFragment on LatestThreadActionLog {
  userFirstName
  userLastName
  actionType
}
    `;
export const ThreadFragmentFragmentDocGQLType = gql`
    fragment ThreadFragment on Thread {
  threadId
  created_at
  updated_at
  pinned
  resolved
  comments {
    ...CommentFragment
  }
  threadPermissions {
    ...ThreadPermissionsFragment
  }
  latestActionLog {
    ...LatestThreadActionLogFragment
  }
}
    ${CommentFragmentFragmentDocGQLType}
${ThreadPermissionsFragmentFragmentDocGQLType}
${LatestThreadActionLogFragmentFragmentDocGQLType}`;
export const GetThreadsForOrganizationDocumentGQLType = gql`
    query GetThreadsForOrganization($organizationId: UUID!) {
  threadsForOrganization(organizationId: $organizationId) {
    threadId
    created_at
    updated_at
    pinned
    resolved
    comments {
      id
      created_at
      updated_at
      comment
      authorUserId
      authorFirstName
      authorLastName
      authorOrganizationId
      authorOrganizationSlug
      authorOrganizationName
    }
    threadPermissions {
      organizationId
      organizationSlug
      organizationName
    }
    latestActionLog {
      userFirstName
      userLastName
      actionType
    }
  }
}
    `;

/**
 * __useGetThreadsForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetThreadsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetThreadsForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetThreadsForOrganizationQueryGQLType, GetThreadsForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadsForOrganizationQueryGQLType, GetThreadsForOrganizationQueryVariablesGQLType>(GetThreadsForOrganizationDocumentGQLType, options);
      }
export function useGetThreadsForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadsForOrganizationQueryGQLType, GetThreadsForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadsForOrganizationQueryGQLType, GetThreadsForOrganizationQueryVariablesGQLType>(GetThreadsForOrganizationDocumentGQLType, options);
        }
export type GetThreadsForOrganizationQueryHookResult = ReturnType<typeof useGetThreadsForOrganizationQuery>;
export type GetThreadsForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadsForOrganizationLazyQueryGQLType>;
export type GetThreadsForOrganizationQueryResultGQLType = Apollo.QueryResult<GetThreadsForOrganizationQueryGQLType, GetThreadsForOrganizationQueryVariablesGQLType>;
export const GetThreadIdsForOrganizationDocumentGQLType = gql`
    query GetThreadIdsForOrganization($organizationId: UUID!) {
  threadIds(organizationId: $organizationId)
}
    `;

/**
 * __useGetThreadIdsForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetThreadIdsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadIdsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadIdsForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetThreadIdsForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetThreadIdsForOrganizationQueryGQLType, GetThreadIdsForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadIdsForOrganizationQueryGQLType, GetThreadIdsForOrganizationQueryVariablesGQLType>(GetThreadIdsForOrganizationDocumentGQLType, options);
      }
export function useGetThreadIdsForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadIdsForOrganizationQueryGQLType, GetThreadIdsForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadIdsForOrganizationQueryGQLType, GetThreadIdsForOrganizationQueryVariablesGQLType>(GetThreadIdsForOrganizationDocumentGQLType, options);
        }
export type GetThreadIdsForOrganizationQueryHookResult = ReturnType<typeof useGetThreadIdsForOrganizationQuery>;
export type GetThreadIdsForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadIdsForOrganizationLazyQueryGQLType>;
export type GetThreadIdsForOrganizationQueryResultGQLType = Apollo.QueryResult<GetThreadIdsForOrganizationQueryGQLType, GetThreadIdsForOrganizationQueryVariablesGQLType>;
export const GetThreadsDocumentGQLType = gql`
    query GetThreads($threadIds: [UUID!]!) {
  threads(threadIds: $threadIds) {
    threadId
    created_at
    updated_at
    pinned
    resolved
    comments {
      id
      created_at
      updated_at
      comment
      authorUserId
      authorFirstName
      authorLastName
      authorOrganizationId
      authorOrganizationSlug
      authorOrganizationName
    }
    threadPermissions {
      organizationId
      organizationSlug
      organizationName
    }
    latestActionLog {
      userFirstName
      userLastName
      actionType
    }
  }
}
    `;

/**
 * __useGetThreadsQuery__
 *
 * To run a query within a React component, call `useGetThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsQuery({
 *   variables: {
 *      threadIds: // value for 'threadIds'
 *   },
 * });
 */
export function useGetThreadsQuery(baseOptions: Apollo.QueryHookOptions<GetThreadsQueryGQLType, GetThreadsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadsQueryGQLType, GetThreadsQueryVariablesGQLType>(GetThreadsDocumentGQLType, options);
      }
export function useGetThreadsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadsQueryGQLType, GetThreadsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadsQueryGQLType, GetThreadsQueryVariablesGQLType>(GetThreadsDocumentGQLType, options);
        }
export type GetThreadsQueryHookResult = ReturnType<typeof useGetThreadsQuery>;
export type GetThreadsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadsLazyQueryGQLType>;
export type GetThreadsQueryResultGQLType = Apollo.QueryResult<GetThreadsQueryGQLType, GetThreadsQueryVariablesGQLType>;
export const GetThreadDocumentGQLType = gql`
    query GetThread($threadId: UUID!) {
  thread(threadId: $threadId) {
    threadId
    created_at
    updated_at
    pinned
    resolved
    comments {
      id
      created_at
      updated_at
      comment
      authorUserId
      authorFirstName
      authorLastName
      authorOrganizationId
      authorOrganizationSlug
      authorOrganizationName
    }
    threadPermissions {
      organizationId
      organizationSlug
      organizationName
    }
    latestActionLog {
      userFirstName
      userLastName
      actionType
    }
  }
}
    `;

/**
 * __useGetThreadQuery__
 *
 * To run a query within a React component, call `useGetThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetThreadQuery(baseOptions: Apollo.QueryHookOptions<GetThreadQueryGQLType, GetThreadQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadQueryGQLType, GetThreadQueryVariablesGQLType>(GetThreadDocumentGQLType, options);
      }
export function useGetThreadLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadQueryGQLType, GetThreadQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadQueryGQLType, GetThreadQueryVariablesGQLType>(GetThreadDocumentGQLType, options);
        }
export type GetThreadQueryHookResult = ReturnType<typeof useGetThreadQuery>;
export type GetThreadLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadLazyQueryGQLType>;
export type GetThreadQueryResultGQLType = Apollo.QueryResult<GetThreadQueryGQLType, GetThreadQueryVariablesGQLType>;
export const CreateThreadActionDocumentGQLType = gql`
    mutation CreateThreadAction($userId: UUID!, $threadId: UUID!, $action: ThreadAction!) {
  createThreadAction(userId: $userId, threadId: $threadId, action: $action) {
    threadId
    created_at
    updated_at
    pinned
    resolved
    comments {
      id
      created_at
      updated_at
      comment
      authorUserId
      authorFirstName
      authorLastName
      authorOrganizationId
      authorOrganizationSlug
      authorOrganizationName
    }
    threadPermissions {
      organizationId
      organizationSlug
      organizationName
    }
    latestActionLog {
      userFirstName
      userLastName
      actionType
    }
  }
}
    `;
export type CreateThreadActionMutationFnGQLType = Apollo.MutationFunction<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>;

/**
 * __useCreateThreadActionMutation__
 *
 * To run a mutation, you first call `useCreateThreadActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadActionMutation, { data, loading, error }] = useCreateThreadActionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      threadId: // value for 'threadId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useCreateThreadActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>(CreateThreadActionDocumentGQLType, options);
      }
export type CreateThreadActionMutationHookResult = ReturnType<typeof useCreateThreadActionMutation>;
export type CreateThreadActionMutationResultGQLType = Apollo.MutationResult<CreateThreadActionMutationGQLType>;
export type CreateThreadActionMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>;
export const CreateNewCommentDocumentGQLType = gql`
    mutation CreateNewComment($threadId: UUID!, $comment: String!, $authorUserId: UUID!) {
  newComment(threadId: $threadId, comment: $comment, authorUserId: $authorUserId)
}
    `;
export type CreateNewCommentMutationFnGQLType = Apollo.MutationFunction<CreateNewCommentMutationGQLType, CreateNewCommentMutationVariablesGQLType>;

/**
 * __useCreateNewCommentMutation__
 *
 * To run a mutation, you first call `useCreateNewCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCommentMutation, { data, loading, error }] = useCreateNewCommentMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      comment: // value for 'comment'
 *      authorUserId: // value for 'authorUserId'
 *   },
 * });
 */
export function useCreateNewCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewCommentMutationGQLType, CreateNewCommentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewCommentMutationGQLType, CreateNewCommentMutationVariablesGQLType>(CreateNewCommentDocumentGQLType, options);
      }
export type CreateNewCommentMutationHookResult = ReturnType<typeof useCreateNewCommentMutation>;
export type CreateNewCommentMutationResultGQLType = Apollo.MutationResult<CreateNewCommentMutationGQLType>;
export type CreateNewCommentMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateNewCommentMutationGQLType, CreateNewCommentMutationVariablesGQLType>;